import {appendQueryString} from "@pg-mono/request";

// TODO: below sizes are based on currently existing interfaces, need verification based on actual image usage. Consider these definitions as PoC
type AllowedHeight = 87 | 211 | 248 | 440 | 428 | 552;
type AllowedWidth = 155 | 375 | 440 | 500 | 750 | 760 | 983 | 1500;
type AllowedSize = {width: AllowedWidth; height?: AllowedHeight};

/**
 * Creates image links with specified width and height param. Only use with images from S3 bucket. Only some sizes are allowed.
 * Configuration documentation: https://git.rynekpierwotny.com/propertygroup/cbi/-/tree/master/aws/thumbnails#dozwolone-rozmiary-miniatur
 * @param base - image url
 * @param size
 */
export const getThumbnailLink = (base: string, size: AllowedSize) => {
    return appendQueryString(base, {width: size.width || null, height: size.height, format: "auto"});
};
import {appendQueryString} from "@pg-mono/request";

// TODO: below sizes are based on currently existing interfaces, need verification based on actual image usage. Consider these definitions as PoC
type AllowedHeight = 87 | 211 | 248 | 440 | 428 | 552;
type AllowedWidth = 155 | 375 | 440 | 500 | 750 | 760 | 983 | 1500;
type AllowedSize = {width: AllowedWidth; height?: AllowedHeight};

/**
 * Creates image links with specified width and height param. Only use with images from S3 bucket. Only some sizes are allowed.
 * Configuration documentation: https://git.rynekpierwotny.com/propertygroup/cbi/-/tree/master/aws/thumbnails#dozwolone-rozmiary-miniatur
 * @param base - image url
 * @param size
 */
export const getThumbnailLink = (base: string, size: AllowedSize) => {
    return appendQueryString(base, {width: size.width || null, height: size.height, format: "auto"});
};
